import { apiRequest } from './client'
import type { ApiKey, CreatedApiKey } from './types'

export const integrationsApi = {
  listApiKeys: () => apiRequest<{ data: ApiKey[] }>('/integrations/api-keys'),

  createApiKey: (input: { name: string; scopes: string[] }) =>
    apiRequest<{ data: CreatedApiKey }>('/integrations/api-keys', { method: 'POST', body: input }),

  revokeApiKey: (id: string) => apiRequest<{ data: { success: boolean } }>(`/integrations/api-keys/${id}`, { method: 'DELETE' }),
}
